<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Add Bell</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <form>
          <div class="form-group">
            <label for="ddlZoneCopyFrom">Copy Zone Schedule</label>
            <select class="form-control" id="ddlZoneCopyFrom" v-model="copyFromZoneId">
              <option value="0">Select..</option>
              <option v-for="zone in filtered_zones" :key="zone.zone_id" v-bind:value="zone.zone_id">[{{ zone.site.name }}] {{ zone.name }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="ddlZoneCopyTo">Zone Schedule to copy to</label>
            <select class="form-control" id="ddlZoneCopyTo" v-model="copyToZoneId">
              <option value="0">Select..</option>
              <option v-for="zone in filtered_zones" :key="zone.zone_id" v-bind:value="zone.zone_id">[{{ zone.site.name }}] {{ zone.name }}
              </option>
            </select>
          </div>
          <button type="button" class="btn btn-hub-primary" @click="submit()" >Submit</button>
          <router-link :to="{ name: 'DayScheduler' }" class="btn btn-secondary">Cancel</router-link>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: [
    'day_schedule_id'
  ],
  data: function () {
    return {
      copyFromZoneId: 0,
      copyToZoneId: 0
    }
  },
  computed: {
    ...mapGetters({
      zones: 'allZones',
      scoped_site_id: 'scopedSiteId'
    }),
    filtered_zones: function () {
      return this.zones.filter(zone => (zone.site_id === this.scoped_site_id) || this.scoped_site_id === 1)
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getZones')
  },
  methods: {
    submit () {
      this.$store.dispatch('copyDayScheduleItemZone', {
        day_schedule_id: this.day_schedule_id,
        zone_id_copy_from: this.copyFromZoneId,
        zone_id_copy_to: this.copyToZoneId
      })
    }
  }
}
</script>

<style scoped>
</style>
